import { render, staticRenderFns } from "./AccountAuditLogs.vue?vue&type=template&id=008093f8&"
import script from "./AccountAuditLogs.vue?vue&type=script&lang=js&"
export * from "./AccountAuditLogs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports